const peizhis = {
	order_status:[
		{label:"待支付",value:'-100'},
		{label:"已支付",value:'100'},
		{label:"待解密",value:'101'},
		{label:"刷单拦截",value:'110'},
		{label:"初步审核",value:'120'},
		{label:"待完善证件信息",value:'150'},
		{label:"待审核",value:'200'},
		{label:"待开卡",value:'450'},
		{label:"已领取",value:'460'},
		{label:"开卡中",value:'470'},
		{label:"待发货",value:'500'},
		{label:"已发货",value:'550'},
		{label:"已退货",value:'-700'},
		{label:"已激活",value:'5000'},
		{label:"开卡失败",value:'-460'},
		{label:"证件不合格待重传",value:'-200'},
		{label:"订单终止",value:'0'},
	]
}
export default peizhis


// WEBPACK FOOTER //
// ./src/assets/peizhi.js